<template>
  <ion-page>
    <master-layout pageTitle="لیست محصولات انبار">
      <ion-card>
        <ion-card-content>
          <DataTable auto-reload="1" :headers="headers" :route="'WarehouseInvoice/ListAjax/'+id"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      headers:['شماره فاکتور','شماره حواله','نوع','توسط','تاریخ','امکانات']
    };
  },
  async created()
  {
    this.id = this.$route.params.warehouseId;
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>